/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Metadata_Install1Inputs */

const id_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasang:`)
};

const ms_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasang:`)
};

const da_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installér:`)
};

const de_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installation:`)
};

const en_us2_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install:`)
};

const es_es2_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instalación:`)
};

const es_mx2_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instalación:`)
};

const fil_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-install:`)
};

const fr_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installation :`)
};

const it_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installazione:`)
};

const hu_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telepítés:`)
};

const nl_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installatie:`)
};

const no_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installasjon:`)
};

const pl_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instalacja:`)
};

const pt_br2_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instalar:`)
};

const pt_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instalar:`)
};

const ro_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instalare:`)
};

const fi_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asennus:`)
};

const sv_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installation:`)
};

const vi_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cài đặt:`)
};

const tr_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurulum:`)
};

const cs_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instalace:`)
};

const bg_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инсталиране:`)
};

const ru_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Установка:`)
};

const uk_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встановлення:`)
};

const ar_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التثبيت:`)
};

const hi_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इंस्टॉल:`)
};

const th_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดตั้ง:`)
};

const ja_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インストール：`)
};

const zh_cn2_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安装:`)
};

const zh_hant1_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安裝：`)
};

const ko_offerdetail_metadata_install1 = /** @type {(inputs: Offerdetail_Metadata_Install1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`설치:`)
};

/**
* | output |
* | --- |
* | "Install:" |
*
* @param {Offerdetail_Metadata_Install1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_metadata_install1 = /** @type {((inputs?: Offerdetail_Metadata_Install1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Metadata_Install1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_metadata_install1(inputs)
	if (locale === "ms") return ms_offerdetail_metadata_install1(inputs)
	if (locale === "da") return da_offerdetail_metadata_install1(inputs)
	if (locale === "de") return de_offerdetail_metadata_install1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_metadata_install1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_metadata_install1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_metadata_install1(inputs)
	if (locale === "fil") return fil_offerdetail_metadata_install1(inputs)
	if (locale === "fr") return fr_offerdetail_metadata_install1(inputs)
	if (locale === "it") return it_offerdetail_metadata_install1(inputs)
	if (locale === "hu") return hu_offerdetail_metadata_install1(inputs)
	if (locale === "nl") return nl_offerdetail_metadata_install1(inputs)
	if (locale === "no") return no_offerdetail_metadata_install1(inputs)
	if (locale === "pl") return pl_offerdetail_metadata_install1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_metadata_install1(inputs)
	if (locale === "pt") return pt_offerdetail_metadata_install1(inputs)
	if (locale === "ro") return ro_offerdetail_metadata_install1(inputs)
	if (locale === "fi") return fi_offerdetail_metadata_install1(inputs)
	if (locale === "sv") return sv_offerdetail_metadata_install1(inputs)
	if (locale === "vi") return vi_offerdetail_metadata_install1(inputs)
	if (locale === "tr") return tr_offerdetail_metadata_install1(inputs)
	if (locale === "cs") return cs_offerdetail_metadata_install1(inputs)
	if (locale === "bg") return bg_offerdetail_metadata_install1(inputs)
	if (locale === "ru") return ru_offerdetail_metadata_install1(inputs)
	if (locale === "uk") return uk_offerdetail_metadata_install1(inputs)
	if (locale === "ar") return ar_offerdetail_metadata_install1(inputs)
	if (locale === "hi") return hi_offerdetail_metadata_install1(inputs)
	if (locale === "th") return th_offerdetail_metadata_install1(inputs)
	if (locale === "ja") return ja_offerdetail_metadata_install1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_metadata_install1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_metadata_install1(inputs)
	return ko_offerdetail_metadata_install1(inputs)
});
export { offerdetail_metadata_install1 as "offerDetail.metadata.install" }